module.exports = __webpack_public_path__ + "img/Tokelau.c5c64a92.png";